import { render, staticRenderFns } from "./StoriesArticleAudioPlayerMainDuration.vue?vue&type=template&id=6f908f52&scoped=true&"
import script from "./StoriesArticleAudioPlayerMainDuration.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleAudioPlayerMainDuration.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleAudioPlayerMainDuration.vue?vue&type=style&index=0&id=6f908f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f908f52",
  null
  
)

export default component.exports